module.exports = __webpack_public_path__ + "static/media/kv-all-slots.71d394bd.jpeg";